<template>
    <div
        class="tip-container patsnap-biz-smart-search-tip"
        :class="`tip-container__${tipData.type}`"
        :style="containerStyle"
    >
        <span
            class="arrow-container"
            :style="arrowPos"
        >
            <span class="arrow" />
        </span>
        <div class="tip-content">
            {{ tipData.message }}
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import $ from 'jquery';

export default {
    props: {
        tipData: {
            default: () => ({}),
        },
    },
    data() {
        return {
            containerStyle: {},
            arrowPos: null,
            width: 'auto',
            originalParent: null, // 保存原始父元素引用
        };
    },
    watch: {
        tipData() {
            this.getStyle();
        },
    },
    mounted() {
        // 使用 $nextTick 确保 Vue 完成首次渲染后再执行 Portal
        this.$nextTick(() => {
            // Portal: 保存原始父元素引用（用于获取宽度）
            this.originalParent = this.$el.parentNode || this.$parent.$el;

            // Portal: 将元素移动到 body，避免被父元素的 overflow: hidden 裁剪
            document.body.appendChild(this.$el);

            this.getStyle();
            const pWidth = $(this.originalParent).outerWidth();
            const width = $(this.$el).outerWidth() > pWidth * 0.9 ? pWidth * 0.9 : $(this.$el).outerWidth();
            if (width) {
                this.width = `${width}px`;
            }
        });
    },
    beforeDestroy() {
        // Portal: 清理，从 body 移除元素
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    },
    methods: {
        getStyle() {
            if (this.$el && this.originalParent) {
                // 获取原始父容器的宽度（SmartSearch 组件）
                const pWidth = $(this.originalParent).outerWidth();
                const width = $(this.$el).outerWidth() > pWidth * 0.9 ? pWidth * 0.9 : $(this.$el).outerWidth();
                const { pageX } = this.tipData.target;
                const { pageY } = this.tipData.target;

                // 使用 fixed 定位，相对于 viewport 计算
                // pageX/pageY 已经是相对于页面的绝对坐标
                let left = pageX;
                const top = pageY;

                // 防止溢出右边界（基于原父容器的宽度）
                const parentOffset = $(this.originalParent).offset();
                const parentRight = parentOffset.left + pWidth;
                const tooltipRight = left + width + 10; // 10px 是偏移量

                let arrowLeft = 10;
                if (tooltipRight > parentRight) {
                    // 溢出右边界，向左调整
                    const overWidth = tooltipRight - parentRight;
                    left -= overWidth;
                    arrowLeft = overWidth + 10;
                }

                this.containerStyle = {
                    left: `${left + 10}px`,
                    top: `${top + 20}px`,
                    'max-width': `${pWidth * 0.9}px`,
                    'min-width': this.width,
                };
                this.arrowPos = {
                    left: `${arrowLeft}px`,
                };
            }
        },
    },
};
</script>
